:host {
  display: inline-flex;
  min-inline-size: 0;
  max-inline-size: var(--dimension-menu-width-xs);
}

ds-filter-menu {
  min-inline-size: 0;
  max-inline-size: 100%;
  --ds-choice-popup-min-inline-size: var(--dimension-menu-width-xs);
}
